<section class="statistics">
   <h4 class="bold w-87">{{ 'general.dashboard' | translate }}</h4>
   <main>
      <div class="statistics-2 flex four_cards">
         <div
            (click)="changeValue(0)"
            [ngClass]="{ active: filter == 0 }"
            class="white-bg shadow flex"
         >
            {{ 'general.thesis' | translate }}
         </div>
         <div
            (click)="changeValue(1)"
            [ngClass]="{ active: filter == 1 }"
            class="white-bg shadow flex"
         >
            <h5>
               Thesis with similarity
               <span>0 - 5%</span>
            </h5>
            <img
               style="background: #44bd9e; box-shadow: 0px 3px 15px #44bd9e82"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#44bd9e">
                  <g fill="#44bd9e">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
            </svg>
         </div>
         <div
            (click)="changeValue(2)"
            [ngClass]="{ active: filter == 2 }"
            class="white-bg shadow flex"
         >
            <h5>
               Thesis with similarity
               <span>5 - 20%</span>
            </h5>
            <img
               style="background: #f9a241; box-shadow: 0px 3px 15px #f9a241"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#f9a241">
                  <g fill="#f9a241">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
            </svg>
         </div>
         <div
            (click)="changeValue(3)"
            class="white-bg shadow flex"
            [ngClass]="{ active: filter == 3 }"
         >
            <h5>
               Thesis with similarity
               <span>20 - 100%</span>
            </h5>
            <img
               style="background: #f26f87; box-shadow: 0px 3px 15px #f26f8782"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#f26f87">
                  <g fill="#f26f87">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
            </svg>
         </div>
      </div>
      <div class="statistics-2 flex four_cards">
         <div
            (click)="changeValue(4)"
            [ngClass]="{ active: filter == 4 }"
            class="white-bg shadow flex"
         >
            {{ 'app.upload.drafts' | translate }}
         </div>
         <div
            (click)="changeValue(5)"
            [ngClass]="{ active: filter == 5 }"
            class="white-bg shadow flex"
         >
            <h5>
               Drafts with similarity
               <span>0 - 5%</span>
            </h5>
            <img
               style="background: #44bd9e; box-shadow: 0px 3px 15px #44bd9e82"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#44bd9e">
                  <g fill="#44bd9e">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#44bd9e">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
               <g fill="#44bd9e"></g>
            </svg>
         </div>
         <div
            (click)="changeValue(6)"
            [ngClass]="{ active: filter == 6 }"
            class="white-bg shadow flex"
         >
            <h5>
               Drafts with similarity
               <span>5 - 20%</span>
            </h5>
            <img
               style="background: #f9a241; box-shadow: 0px 3px 15px #f9a241"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#f9a241">
                  <g fill="#f9a241">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f9a241">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
               <g fill="#f9a241"></g>
            </svg>
         </div>
         <div
            (click)="changeValue(7)"
            class="white-bg shadow flex"
            [ngClass]="{ active: filter == 7 }"
         >
            <h5>
               Drafts with similarity
               <span>20 - 100%</span>
            </h5>
            <img
               style="background: #f26f87; box-shadow: 0px 3px 15px #f26f8782"
               src="../../assets/images/document.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               version="1.1"
               id="Capa_1"
               width="40px"
               viewBox="0 0 480 480"
               style="enable-background: new 0 0 480 480"
               xml:space="preserve"
               class="files-icon"
            >
               <g fill="#f26f87">
                  <g fill="#f26f87">
                     <path
                        d="M160,344h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,344,160,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,344H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,344,384,344z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,296h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,296,160,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,296H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,296,384,296z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,248h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,248,160,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,248H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,248,384,248z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,200h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,200,160,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,200H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,200,384,200z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M160,152h-16c-4.418,0-8,3.582-8,8s3.582,8,8,8h16c4.418,0,8-3.582,8-8S164.418,152,160,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M384,152H192c-4.418,0-8,3.582-8,8s3.582,8,8,8h192c4.418,0,8-3.582,8-8S388.418,152,384,152z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M439.896,119.496c-0.04-0.701-0.177-1.393-0.408-2.056c-0.088-0.256-0.152-0.504-0.264-0.752    c-0.389-0.87-0.931-1.664-1.6-2.344l-112-112c-0.68-0.669-1.474-1.211-2.344-1.6c-0.248-0.112-0.496-0.176-0.744-0.264    c-0.669-0.23-1.366-0.37-2.072-0.416C320.328,0.088,320.176,0,320,0H96c-4.418,0-8,3.582-8,8v24H48c-4.418,0-8,3.582-8,8v432    c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-40h40c4.418,0,8-3.582,8-8V120C440,119.824,439.912,119.672,439.896,119.496z     M328,27.312L412.688,112H328V27.312z M376,464H56V48h32v376c0,4.418,3.582,8,8,8h280V464z M424,416H104V16h208v104    c0,4.418,3.582,8,8,8h104V416z"
                     />
                  </g>
               </g>
               <g>
                  <g fill="#f26f87">
                     <path
                        d="M192,72h-48c-4.418,0-8,3.582-8,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V80C200,75.582,196.418,72,192,72z     M184,120h-32V88h32V120z"
                     />
                  </g>
               </g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
               <g fill="#f26f87"></g>
            </svg>
         </div>
      </div>
      <div class="shadowBorder">
         <div
            class="flex filter"
            *ngIf="
               this.submissionsDetails?.totalSubmissions !== 0 ||
               (this.submissionsDetails?.totalSubmissions == 0 &&
                  title !== undefined)
            "
         >
            <h3 class="bold">Students Documents</h3>
            <div class="input">
               <i class="fas fa-search"></i>
               <input
                  [(ngModel)]="title"
                  (ngModelChange)="titleFilter()"
                  class="search"
                  type="text"
                  [placeholder]="'placeholders.search' | translate"
               />
            </div>
         </div>
         <div
            class="scroll"
            *ngIf="this.submissionsDetails?.totalSubmissions !== 0"
         >
            <i
               class="
                  animate__shakeX animate__animated
                  fas
                  fa-long-arrow-alt-right
               "
            ></i>
            <table>
               <tr>
                  <th>
                     <h5 class="bold left">
                        {{ 'general.table.name' | translate }}
                     </h5>
                  </th>
                  <th>
                     <h5 class="bold left">{{ 'app.student_name' | translate }}</h5>
                  </th>
                  <th>
                     <h5 class="bold">{{ 'general.date' | translate }}</h5>
                  </th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.table.number_of_words' | translate }}
                     </h5>
                  </th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.language' | translate }}
                     </h5>
                  </th>
                  <th><h5 class="bold">{{ 'general.translated_language' | translate }}</h5></th>
                  <th>
                     <h5 class="bold">
                        {{ 'general.table.similarity_report' | translate }}
                     </h5>
                  </th>
                  <th>
                     <h5 class="bold">{{ 'app.access' | translate }}</h5>
                  </th>
                  <th>
                     <h5 class="bold">{{ 'general.table.draft' | translate }}</h5>
                  </th>
               </tr>
               <tr
                  *ngFor="
                     let submission of this.submissionsDetails?.submissions
                        | paginate
                           : {
                                itemsPerPage: 5,
                                currentPage: page,
                                totalItems:
                                   this.submissionsDetails?.totalSubmissions
                             }
                  "
               >
                  <ng-container *ngIf="submission.showSubmission == true">
                     <td>
                        <h5 class="left">{{ submission.title }}</h5>
                     </td>
                     <td>
                        <h5 class="left">{{ submission.user.name }}</h5>
                     </td>
                     <td>
                        <h5>
                           {{ submission.createdAt | localTime }}
                        </h5>
                     </td>
                     <td>
                        <h5>{{ submission.wordCount }}</h5>
                     </td>
                     <td>
                        <h5
                           *ngIf="submission.processed == 1"
                           [ngClass]="{
                              'red-border':
                                 submission.originalPercentage.toFixed(2) > 20,
                              'green-border':
                                 submission.originalPercentage.toFixed(2) >=
                                    0 &&
                                 submission.originalPercentage.toFixed(2) < 5,
                              'orange-border':
                                 submission.originalPercentage.toFixed(2) >=
                                    5 &&
                                 submission.originalPercentage.toFixed(2) <= 20
                           }"
                        >
                           <span *ngIf="submission.originalLanguage !== null"
                              >{{ submission.originalLanguage | uppercase }}
                           </span>
                           <span *ngIf="submission.originalLanguage == null">
                              --
                           </span>

                           {{ submission.originalPercentage.toFixed(2) }}%
                        </h5>
                        <h5
                           *ngIf="submission.processed == 2"
                           class="gray-border"
                        >
                           {{ 'app.suspended' | translate }}
                        </h5>
                        <h5
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           class="gray-border"
                        >
                           {{ 'report.processing' | translate }}
                        </h5>
                     </td>
                     <td>
                        <h5
                           *ngIf="submission.processed == 1"
                           [ngClass]="{
                              'red-border':
                                 submission.translatedPercentage.toFixed(2) >
                                 20,

                              'green-border':
                                 submission.translatedPercentage.toFixed(2) >=
                                    0 &&
                                 submission.translatedPercentage.toFixed(2) < 5,

                              'orange-border':
                                 submission.translatedPercentage.toFixed(2) >=
                                    5 &&
                                 submission.translatedPercentage.toFixed(2) <=
                                    20,

                              'gray-border':
                                 submission.translatedLanguage == null
                           }"
                        >
                           <span *ngIf="submission.translatedLanguage !== null"
                              >{{ submission.translatedLanguage | uppercase }}
                           </span>
                           <span *ngIf="submission.translatedLanguage == null">
                              --
                           </span>
                           <ng-container
                              *ngIf="submission.translatedLanguage !== null"
                           >
                              {{ submission.translatedPercentage.toFixed(2) }}%
                           </ng-container>

                           <ng-container
                              *ngIf="submission.translatedLanguage == null"
                           >
                              ---
                           </ng-container>
                        </h5>
                        <h5
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           class="gray-border"
                        >
                           {{ 'report.processing' | translate }}
                        </h5>
                        <h5
                           *ngIf="submission.processed == 2"
                           class="gray-border"
                        >
                           {{ 'app.suspended' | translate }}
                        </h5>
                     </td>
                     <td>
                        <a
                           *ngIf="submission.processed == 1"
                           (click)="goToLink(submission.id)"
                           class="blue-btn"
                           >{{ 'general.report' | translate }}</a
                        >

                        <a
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                           (click)="
                              showWarning('Document is still processing.')
                           "
                           class="disable-btn"
                           >{{ 'general.report' | translate }}</a
                        >
                        <a
                           *ngIf="submission.processed == 2"
                           (click)="showAlertMessage()"
                           class="yellow-btn"
                        >
                           <svg
                              width="468"
                              height="431"
                              viewBox="0 0 468 431"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M406.65 122.69C405.98 111.19 392.44 102.39 364.73 94.95C365.5 93.01 365.96 90.95 366.08 88.86V41.51C363.38 2.26999 202.37 0.919983 183.43 0.919983C165.16 0.919983 3.48003 2.26999 0.780029 41.51V42.18V88.86C0.780029 101.71 17.69 111.86 42.05 119.3C42.05 120.65 41.38 121.33 41.38 122.68V123.35V170.03C15 176.8 1.47003 185.59 0.79003 197.09V197.76V244.44C0.79003 253.24 8.91003 260.68 21.75 267.44C21.2 268.72 20.97 270.11 21.08 271.5V272.17V318.85C21.08 341.17 71.81 355.38 127.99 362.14H130.02C140.84 363.49 151.67 364.17 162.49 364.84H163.84C177.37 365.51 191.58 366.19 203.75 366.19C215.92 366.19 230.13 365.52 243.66 364.84H245.01C255.83 364.17 266.66 363.49 277.48 362.14H279.51C335.66 355.37 386.42 341.84 386.42 318.85V271.5C385.75 263.38 378.98 256.62 364.77 250.54C365.54 248.6 366 246.54 366.12 244.45V200.48C390.47 193.04 406.71 182.87 406.71 170.04V122.67L406.65 122.69ZM393.12 123.36C392.45 128.1 382.3 134.18 363.35 139.6C339.67 147.04 301.79 153.81 254.43 155.84H193.55C146.18 153.81 108.31 147.04 84.63 139.6C66.36 134.19 55.54 128.1 54.86 123.36V122.69H56.21L64.33 124.72C78.85 127.79 93.53 130.05 108.3 131.49C119.12 132.84 130.62 133.52 142.12 134.19C150.24 134.86 159.03 134.86 167.15 135.54H193.53C242.92 134.87 288.24 128.77 320.03 119.98C321.38 119.31 322.73 119.31 324.09 118.63C324.76 118.63 326.12 117.96 326.79 117.96C329.19 117.48 331.48 116.56 333.56 115.26C334.23 115.26 334.23 115.26 334.91 114.59C336.75 114.03 338.56 113.35 340.32 112.56C340.83 112.49 341.31 112.25 341.67 111.89C343.7 111.22 345.05 109.86 347.08 109.19C347.75 108.52 348.43 108.52 349.11 107.84C349.78 107.16 350.46 107.17 351.81 106.49C352.48 106.49 352.48 105.82 353.16 105.82C384.32 113.22 392.44 120.66 393.12 123.36ZM184.08 14.45C295.7 14.45 351.85 32.06 353.2 42.19C352.53 46.93 341.7 53.01 323.43 58.43C299.75 65.87 261.87 72.64 214.51 74.67H153.63C106.26 72.64 68.39 65.87 44.72 58.43C26.45 53.02 15.63 46.93 14.95 42.19C15.63 32.04 72.44 14.45 184.08 14.45ZM47.41 182.89C56.88 192.36 76.5 199.8 100.18 205.21C100.85 205.21 101.53 205.21 101.53 205.88C103.56 206.55 104.91 206.55 106.94 207.23C132.12 212.47 157.69 215.64 183.38 216.7C192.85 217.37 201.65 217.37 211.79 218.05H238.17C246.97 218.05 255.78 217.38 264.55 216.7C290.71 215.38 316.72 211.99 342.35 206.55C335.89 209.96 329.09 212.68 322.05 214.67C297.02 222.79 256.43 229.55 205.02 230.91H152.28C104.91 228.88 67.04 222.11 43.36 214.67C24.42 209.26 14.27 202.51 13.59 198.43C15.62 195.05 22.39 188.96 47.42 182.88L47.41 182.89ZM372.8 272.19C372.13 276.93 361.98 283.01 343.03 288.43C319.35 295.87 281.47 302.64 234.11 304.67H173.25C125.88 302.64 88.01 295.87 64.34 288.43C46.73 283.02 35.93 276.93 34.57 272.19L40.66 274.22H41.33C43.04 274.99 44.87 275.44 46.74 275.57C47.41 275.57 48.09 276.24 48.77 276.24C50.12 276.24 50.8 276.91 52.15 276.91C81.7 283.85 111.81 288.15 142.12 289.76C152.94 290.43 163.08 290.43 173.91 291.11H194.21C204.36 291.11 213.83 290.44 223.3 289.76C234.8 289.09 246.3 287.73 257.12 287.06H257.79C269.95 285.71 281.47 283.68 291.61 281.65C293.64 280.98 295.67 280.98 298.38 280.3H299.73C316.9 277.37 333.54 271.9 349.1 264.07C349.77 263.4 350.45 263.4 351.13 262.72C351.8 262.04 352.48 262.05 353.16 261.37C353.84 260.69 354.51 260.7 355.19 260.02C368.73 266.11 372.79 270.85 372.79 272.2L372.8 272.19Z"
                                 fill="white"
                              />
                              <path
                                 d="M365.11 430.92C421.835 430.92 467.82 384.935 467.82 328.21C467.82 271.485 421.835 225.5 365.11 225.5C308.385 225.5 262.4 271.485 262.4 328.21C262.4 384.935 308.385 430.92 365.11 430.92Z"
                                 fill="#ECC332"
                              />
                              <path
                                 d="M365.1 430.92C308.46 430.92 262.39 384.85 262.39 328.21C262.39 271.57 308.47 225.5 365.1 225.5C421.74 225.5 467.81 271.57 467.81 328.21C467.81 384.85 421.74 430.92 365.1 430.92ZM365.1 259.04C326.96 259.04 295.93 290.07 295.93 328.21C295.93 366.35 326.96 397.38 365.1 397.38C403.24 397.38 434.27 366.35 434.27 328.21C434.27 290.07 403.25 259.04 365.1 259.04Z"
                                 fill="white"
                              />
                              <path
                                 d="M393.37 337.645H374.24V356.322H356.808V337.645H337.565V321.119H356.808V302.442H374.24V321.119H393.37V337.645Z"
                                 fill="white"
                              />
                           </svg>
                           {{ 'general.add_credits' | translate }}
                           <div class="fas fa-info-circle tooltip">
                              <div class="left">
                                 <p>
                                    You don't have enough credits. <br />Add
                                    credits or documents to proceed further!.
                                 </p>
                              </div>
                           </div>
                        </a>
                     </td>

                     <td>
                        <ng-container
                           *ngIf="
                              submission.processed == 0 ||
                              submission.processed == -1
                           "
                        >
                           <label class="switch">
                              <input
                                 disabled
                                 [checked]="false"
                                 type="checkbox"
                              />

                              <span
                                 style="opacity: 0.5; cursor: not-allowed"
                                 class="slider round"
                              ></span>
                           </label>
                        </ng-container>
                        <ng-container *ngIf="submission.processed === 1">
                           <label class="switch">
                              <input
                                 disabled
                                 [checked]="submission.isPublic === true"
                                 type="checkbox"
                              />

                              <span
                                 (click)="this.toggleAccess(submission.id)"
                                 class="slider round"
                              ></span> </label
                        ></ng-container>
                     </td>
                     <td>
                        <ng-container *ngIf="submission.reSubmission !== 2">
                           <ng-container
                              *ngIf="
                                 submission.processed == 0 ||
                                 submission.processed == -1
                              "
                           >
                              <label class="switch">
                                 <input
                                    disabled
                                    [checked]="false"
                                    type="checkbox"
                                 />

                                 <span
                                    style="opacity: 0.5; cursor: not-allowed"
                                    class="slider2 round"
                                 ></span>
                              </label>
                           </ng-container>
                           <ng-container *ngIf="submission.processed == 1">
                              <label class="switch">
                                 <input
                                    disabled
                                    [checked]="submission.reSubmission !== 0"
                                    type="checkbox"
                                 />

                                 <span
                                    (click)="this.toggleDraft(submission.id)"
                                    class="slider2 round"
                                 ></span>
                              </label>
                           </ng-container>
                        </ng-container>

                        <ng-container *ngIf="submission.reSubmission === 2">
                           <label class="switch">
                              <input
                                 disabled
                                 [checked]="true"
                                 type="checkbox"
                              />

                              <span
                                 style="opacity: 0.5; cursor: not-allowed"
                                 class="slider2 round"
                              ></span>
                           </label>
                        </ng-container>
                     </td>
                  </ng-container>
               </tr>
            </table>
         </div>
         <pagination-controls
            *ngIf="this.submissionsDetails?.totalSubmissions !== 0"
            class="num"
            (pageChange)="changePage($event)"
            autoHide="true"
            responsive="true"
            previousLabel=""
            nextLabel=""
         ></pagination-controls>
      </div>

      <div
         *ngIf="
            this.submissionsDetails?.totalSubmissions === 0 &&
            title == undefined &&
            filter == 0
         "
         class="shadow white-bg zero-state"
      >
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold">
            There are no thesis submitted yet! Check again later.
         </h5>
      </div>

      <div
         *ngIf="this.submissionsDetails?.totalSubmissions === 0 && filter != 0"
         class="shadow white-bg zero-state"
      >
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold">{{ 'app.you_dont_have_any_documents_in_this_range' | translate }}</h5>
      </div>

      <div
         *ngIf="
            this.submissionsDetails?.totalSubmissions === 0 &&
            title !== undefined
         "
         class="shadow white-bg zero-state"
      >
         <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
         <h5 class="bold">
            There are no thesis with this title! Please check your spelling.
         </h5>
      </div>

      <div class="statistics-2 flex three_cards">
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average words per <b style="display: inline">{{ 'general.thesis' | translate }}</b>
               <span>
                  {{ this.statistics?.avgWordsPerDoc || 0 }}
               </span>
            </h5>
            <img
               style="background: #2bb5b770; box-shadow: 0px 3px 15px #2bb5b770"
               src="../../../assets/images/icons/FjaleTeShfrytezuara.png"
               alt=""
            />
            <svg
               height="40px"
               class="files-icon"
               xmlns="http://www.w3.org/2000/svg"
               id="FjaleTeShfrytezuara"
               viewBox="0 0 44.099 52.919"
            >
               <g id="Group_15" data-name="Group 15" transform="translate(0 0)">
                  <path
                     id="Path_47"
                     data-name="Path 47"
                     d="M189.159,134.88H150.94a2.94,2.94,0,0,1,0-5.88h38.219a2.94,2.94,0,1,1,0,5.88Z"
                     transform="translate(-148 -129)"
                     fill="#70c598"
                  />
                  <path
                     id="Path_48"
                     data-name="Path 48"
                     d="M156.82,189.28h-5.88a2.94,2.94,0,0,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                     transform="translate(-148 -171.64)"
                     fill="#70c598"
                  />
               </g>
               <path
                  id="Path_49"
                  data-name="Path 49"
                  d="M250.18,189.28H232.54a2.94,2.94,0,1,1,0-5.88h17.64a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-211.96 -171.64)"
                  fill="#70c598"
               />
               <path
                  id="Path_50"
                  data-name="Path 50"
                  d="M183.279,243.68H150.94a2.94,2.94,0,1,1,0-5.88h32.339a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-148 -214.281)"
                  fill="#70c598"
               />
               <path
                  id="Path_51"
                  data-name="Path 51"
                  d="M168.579,298.08H150.94a2.94,2.94,0,1,1,0-5.88h17.64a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-148 -256.921)"
                  fill="#70c598"
               />
               <path
                  id="Path_52"
                  data-name="Path 52"
                  d="M292.82,298.08h-5.88a2.94,2.94,0,1,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-254.601 -256.921)"
                  fill="#70c598"
               />
               <path
                  id="Path_53"
                  data-name="Path 53"
                  d="M253.119,352.48H232.54a2.94,2.94,0,0,1,0-5.88h20.58a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-211.96 -299.561)"
                  fill="#70c598"
               />
               <path
                  id="Path_54"
                  data-name="Path 54"
                  d="M156.82,352.48h-5.88a2.94,2.94,0,0,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-148 -299.561)"
                  fill="#70c598"
               />
            </svg>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average Thesis similarity for
               <b style="display: inline">{{ 'general.language' | translate }}</b>
               <span
                  >{{
                     this.statistics?.avgMlPlagSimilarity?.toFixed(2) || 0
                  }}%</span
               >
            </h5>
            <img
               style="background: #bd67ff70; box-shadow: 0px 3px 15px #bd67ff70"
               src="../../../assets/images/opacity.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               class="files-icon"
               width="40px"
               height="72.558"
               viewBox="0 0 72.558 72.558"
            >
               <path
                  id="opacity"
                  d="M53.885,18.673A27.7,27.7,0,1,0,18.673,53.885,27.7,27.7,0,1,0,53.885,18.673Zm-49.633,9.1A23.444,23.444,0,0,1,48.774,17.434a28.021,28.021,0,0,0-3.993-.287A27.67,27.67,0,0,0,17.148,44.782a28.021,28.021,0,0,0,.287,3.993A23.4,23.4,0,0,1,4.251,27.776ZM42.731,45.737l-15.91-15.91a23.589,23.589,0,0,1,3.006-3.006l15.91,15.91A23.589,23.589,0,0,1,42.731,45.737Zm-7.743,4.282L22.539,37.57a23.261,23.261,0,0,1,1.831-4.182l14.8,14.8A23.255,23.255,0,0,1,34.988,50.019ZM21.506,42.55l8.5,8.5a23.613,23.613,0,0,1-7.917-.585,23.611,23.611,0,0,1-.585-7.917Zm26.683-3.38-14.8-14.8a23.259,23.259,0,0,1,4.182-1.831l12.45,12.45A23.261,23.261,0,0,1,48.189,39.17Zm2.863-9.162-8.5-8.5a23.612,23.612,0,0,1,7.917.585A23.611,23.611,0,0,1,51.052,30.008Zm-6.27,38.3a23.4,23.4,0,0,1-21-13.183,27.667,27.667,0,0,0,31.34-31.34A23.444,23.444,0,0,1,44.782,68.307Z"
                  fill="#bd67ff"
               />
            </svg>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average Thesis similarity for
               <b style="display: inline">{{ 'general.translated_language' | translate }}</b>
               <span>
                  {{
                     this.statistics?.avgCrossPlagSimilarity?.toFixed(2) || 0
                  }}%</span
               >
            </h5>
            <img
               style="background: #ff000070; box-shadow: 0px 3px 15px #ff000070"
               src="../../../assets/images/icons/red.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               class="files-icon"
               width="40px"
               height="72.558"
               viewBox="0 0 72.558 72.558"
            >
               <path
                  id="opacity"
                  d="M53.885,18.673A27.7,27.7,0,1,0,18.673,53.885,27.7,27.7,0,1,0,53.885,18.673Zm-49.633,9.1A23.444,23.444,0,0,1,48.774,17.434a28.021,28.021,0,0,0-3.993-.287A27.67,27.67,0,0,0,17.148,44.782a28.021,28.021,0,0,0,.287,3.993A23.4,23.4,0,0,1,4.251,27.776ZM42.731,45.737l-15.91-15.91a23.589,23.589,0,0,1,3.006-3.006l15.91,15.91A23.589,23.589,0,0,1,42.731,45.737Zm-7.743,4.282L22.539,37.57a23.261,23.261,0,0,1,1.831-4.182l14.8,14.8A23.255,23.255,0,0,1,34.988,50.019ZM21.506,42.55l8.5,8.5a23.613,23.613,0,0,1-7.917-.585,23.611,23.611,0,0,1-.585-7.917Zm26.683-3.38-14.8-14.8a23.259,23.259,0,0,1,4.182-1.831l12.45,12.45A23.261,23.261,0,0,1,48.189,39.17Zm2.863-9.162-8.5-8.5a23.612,23.612,0,0,1,7.917.585A23.611,23.611,0,0,1,51.052,30.008Zm-6.27,38.3a23.4,23.4,0,0,1-21-13.183,27.667,27.667,0,0,0,31.34-31.34A23.444,23.444,0,0,1,44.782,68.307Z"
                  fill="red"
               />
            </svg>
         </div>
      </div>
      <div class="statistics-2 flex three_cards">
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average words per <b style="display: inline">{{ 'general.table.draft' | translate }}</b>
               <span>
                  {{
                     this.statistics?.averageResubmissionsPlag?.wordCount || 0
                  }}
               </span>
            </h5>
            <img
               style="background: #2bb5b770; box-shadow: 0px 3px 15px #2bb5b770"
               src="../../../assets/images/icons/FjaleTeShfrytezuara.png"
               alt=""
            />
            <svg
               height="40px"
               class="files-icon"
               xmlns="http://www.w3.org/2000/svg"
               id="FjaleTeShfrytezuara"
               viewBox="0 0 44.099 52.919"
            >
               <g id="Group_15" data-name="Group 15" transform="translate(0 0)">
                  <path
                     id="Path_47"
                     data-name="Path 47"
                     d="M189.159,134.88H150.94a2.94,2.94,0,0,1,0-5.88h38.219a2.94,2.94,0,1,1,0,5.88Z"
                     transform="translate(-148 -129)"
                     fill="#70c598"
                  />
                  <path
                     id="Path_48"
                     data-name="Path 48"
                     d="M156.82,189.28h-5.88a2.94,2.94,0,0,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                     transform="translate(-148 -171.64)"
                     fill="#70c598"
                  />
               </g>
               <path
                  id="Path_49"
                  data-name="Path 49"
                  d="M250.18,189.28H232.54a2.94,2.94,0,1,1,0-5.88h17.64a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-211.96 -171.64)"
                  fill="#70c598"
               />
               <path
                  id="Path_50"
                  data-name="Path 50"
                  d="M183.279,243.68H150.94a2.94,2.94,0,1,1,0-5.88h32.339a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-148 -214.281)"
                  fill="#70c598"
               />
               <path
                  id="Path_51"
                  data-name="Path 51"
                  d="M168.579,298.08H150.94a2.94,2.94,0,1,1,0-5.88h17.64a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-148 -256.921)"
                  fill="#70c598"
               />
               <path
                  id="Path_52"
                  data-name="Path 52"
                  d="M292.82,298.08h-5.88a2.94,2.94,0,1,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-254.601 -256.921)"
                  fill="#70c598"
               />
               <path
                  id="Path_53"
                  data-name="Path 53"
                  d="M253.119,352.48H232.54a2.94,2.94,0,0,1,0-5.88h20.58a2.94,2.94,0,1,1,0,5.88Z"
                  transform="translate(-211.96 -299.561)"
                  fill="#70c598"
               />
               <path
                  id="Path_54"
                  data-name="Path 54"
                  d="M156.82,352.48h-5.88a2.94,2.94,0,0,1,0-5.88h5.88a2.94,2.94,0,0,1,0,5.88Z"
                  transform="translate(-148 -299.561)"
                  fill="#70c598"
               />
            </svg>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average Draft similarity for
               <b style="display: inline">{{ 'general.translated_language' | translate }}</b>
               <span
                  >{{
                     this.statistics?.averageResubmissionsPlag?.originalPercentage?.toFixed(
                        2
                     ) || 0
                  }}%</span
               >
            </h5>
            <img
               style="background: #bd67ff70; box-shadow: 0px 3px 15px #bd67ff70"
               src="../../../assets/images/opacity.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               class="files-icon"
               width="40px"
               height="72.558"
               viewBox="0 0 72.558 72.558"
            >
               <path
                  id="opacity"
                  d="M53.885,18.673A27.7,27.7,0,1,0,18.673,53.885,27.7,27.7,0,1,0,53.885,18.673Zm-49.633,9.1A23.444,23.444,0,0,1,48.774,17.434a28.021,28.021,0,0,0-3.993-.287A27.67,27.67,0,0,0,17.148,44.782a28.021,28.021,0,0,0,.287,3.993A23.4,23.4,0,0,1,4.251,27.776ZM42.731,45.737l-15.91-15.91a23.589,23.589,0,0,1,3.006-3.006l15.91,15.91A23.589,23.589,0,0,1,42.731,45.737Zm-7.743,4.282L22.539,37.57a23.261,23.261,0,0,1,1.831-4.182l14.8,14.8A23.255,23.255,0,0,1,34.988,50.019ZM21.506,42.55l8.5,8.5a23.613,23.613,0,0,1-7.917-.585,23.611,23.611,0,0,1-.585-7.917Zm26.683-3.38-14.8-14.8a23.259,23.259,0,0,1,4.182-1.831l12.45,12.45A23.261,23.261,0,0,1,48.189,39.17Zm2.863-9.162-8.5-8.5a23.612,23.612,0,0,1,7.917.585A23.611,23.611,0,0,1,51.052,30.008Zm-6.27,38.3a23.4,23.4,0,0,1-21-13.183,27.667,27.667,0,0,0,31.34-31.34A23.444,23.444,0,0,1,44.782,68.307Z"
                  fill="#bd67ff"
               />
            </svg>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            <h5>
               Average Draft similarity for
               <b style="display: inline">{{ 'general.translated_language' | translate }}</b>
               <span>
                  {{
                     this.statistics?.averageResubmissionsPlag?.translatedPercentage?.toFixed(
                        2
                     ) || 0
                  }}%</span
               >
            </h5>
            <img
               style="background: #ff000070; box-shadow: 0px 3px 15px #ff000070"
               src="../../../assets/images/icons/red.png"
               alt=""
            />
            <svg
               xmlns="http://www.w3.org/2000/svg"
               class="files-icon"
               width="40px"
               height="72.558"
               viewBox="0 0 72.558 72.558"
            >
               <path
                  id="opacity"
                  d="M53.885,18.673A27.7,27.7,0,1,0,18.673,53.885,27.7,27.7,0,1,0,53.885,18.673Zm-49.633,9.1A23.444,23.444,0,0,1,48.774,17.434a28.021,28.021,0,0,0-3.993-.287A27.67,27.67,0,0,0,17.148,44.782a28.021,28.021,0,0,0,.287,3.993A23.4,23.4,0,0,1,4.251,27.776ZM42.731,45.737l-15.91-15.91a23.589,23.589,0,0,1,3.006-3.006l15.91,15.91A23.589,23.589,0,0,1,42.731,45.737Zm-7.743,4.282L22.539,37.57a23.261,23.261,0,0,1,1.831-4.182l14.8,14.8A23.255,23.255,0,0,1,34.988,50.019ZM21.506,42.55l8.5,8.5a23.613,23.613,0,0,1-7.917-.585,23.611,23.611,0,0,1-.585-7.917Zm26.683-3.38-14.8-14.8a23.259,23.259,0,0,1,4.182-1.831l12.45,12.45A23.261,23.261,0,0,1,48.189,39.17Zm2.863-9.162-8.5-8.5a23.612,23.612,0,0,1,7.917.585A23.611,23.611,0,0,1,51.052,30.008Zm-6.27,38.3a23.4,23.4,0,0,1-21-13.183,27.667,27.667,0,0,0,31.34-31.34A23.444,23.444,0,0,1,44.782,68.307Z"
                  fill="red"
               />
            </svg>
         </div>
      </div>
      <div class="shadowBorder chart">
         <apx-chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [xaxis]="chartOptions.xaxis"
            [yaxis]="chartOptions.yaxis"
            [title]="chartOptions.title"
            [dataLabels]="chartOptions.dataLabels"
         ></apx-chart>
      </div>
      <div class="statistics-2 three_cards flex">
         <div class="white-bg shadow flex" style="cursor: auto">
            {{ 'app.total_students' | translate }}
            <span style="color: #f26f87">
               {{ this.statistics?.totalStudents || 0 }}
            </span>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            Active Students
            <span style="color: #f9a241">
               {{ this.statistics?.activeStudents || 0 }}
            </span>
         </div>
         <div class="white-bg shadow flex" style="cursor: auto">
            Inactive Students
            <span style="color: #44bd9e">
               {{ this.statistics?.inActiveStudents || 0 }}
            </span>
         </div>
      </div>
   </main>
</section>
